import { render, staticRenderFns } from "./ImageBtn.vue?vue&type=template&id=51b5a7f9&scoped=true&"
import script from "./ImageBtn.vue?vue&type=script&lang=js&"
export * from "./ImageBtn.vue?vue&type=script&lang=js&"
import style0 from "./ImageBtn.vue?vue&type=style&index=0&id=51b5a7f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b5a7f9",
  null
  
)

export default component.exports